export default [
  {
    path: '/apps/unidade-medida/list',
    name: 'apps-unidade-medida-list',
    component: () => import('@/views/cadastros-gerais/unidade-medida/list/Index.vue'),
    meta: {
      pageTitle: 'Unidade de Medida',
      action: 'read',
      resource: 'UnidadeMedida',
    },
  },
  {
    path: '/apps/unidade-medida/edit/:id',
    name: 'apps-unidade-medida-edit',
    component: () => import('@/views/cadastros-gerais/unidade-medida/edit/EditImagemHome.vue'),
    meta: {
      pageTitle: 'Editar Portador',
      resource: 'AdminHanes',
    },
  },
];
